var map = {
	"./idb/idbLogo-square.png": 423,
	"./idb/idbLogo.png": 3367,
	"./unjspf/unjspfLogo-en.png": 5121,
	"./unjspf/unjspfLogo-fr.png": 4572,
	"./unjspf/unjspfLogo-square-en.png": 3869,
	"./unjspf/unjspfLogo-square-fr.png": 5760
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3013;